import React from 'react';
import Superfriends from './Superfriends';
import Footer from './Footer';
  
export default function Team() {
  return (
    <div className="Teams"
    >
      <h1>This is Our Team</h1>
      <section>
      <h2>We do team work and like making events</h2>
      <Superfriends />
      </section>
      <Footer />
    </div>
  );
};
  